/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../types.generated";
export type GetCompanyNetworkingScansQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetCompanyNetworkingScansQuery = {
  getCompanyNetworkingScans: Array<
    Pick<
      Types.ConnectionHistoryScans,
      | "id"
      | "scanned_attendee_id"
      | "scanning_attendee_id"
      | "got_scanned"
      | "other_claim_id"
      | "other_attendee_name"
      | "representative_name"
    >
  >;
};

export const GetCompanyNetworkingScansDocument = gql`
  query GetCompanyNetworkingScans {
    getCompanyNetworkingScans {
      id
      scanned_attendee_id
      scanning_attendee_id
      got_scanned
      other_claim_id
      other_attendee_name
      representative_name
    }
  }
`;

/**
 * __useGetCompanyNetworkingScansQuery__
 *
 * To run a query within a React component, call `useGetCompanyNetworkingScansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyNetworkingScansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyNetworkingScansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyNetworkingScansQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetCompanyNetworkingScansQuery,
    GetCompanyNetworkingScansQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetCompanyNetworkingScansQuery,
    GetCompanyNetworkingScansQueryVariables
  >(GetCompanyNetworkingScansDocument, baseOptions);
}
export function useGetCompanyNetworkingScansLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCompanyNetworkingScansQuery,
    GetCompanyNetworkingScansQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetCompanyNetworkingScansQuery,
    GetCompanyNetworkingScansQueryVariables
  >(GetCompanyNetworkingScansDocument, baseOptions);
}
export type GetCompanyNetworkingScansQueryHookResult = ReturnType<
  typeof useGetCompanyNetworkingScansQuery
>;
export type GetCompanyNetworkingScansLazyQueryHookResult = ReturnType<
  typeof useGetCompanyNetworkingScansLazyQuery
>;
export type GetCompanyNetworkingScansQueryResult =
  ApolloReactCommon.QueryResult<
    GetCompanyNetworkingScansQuery,
    GetCompanyNetworkingScansQueryVariables
  >;
